/**
 * Created by rkotha on 8/23/2017.
 */
(function() {
    'use strict';

    angular
        .module('nasracApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('sign-out-home-page', {
            parent: 'app',
            url: '/',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/sign-out-home-page/sign-out-home-page.html',
                    controller: 'SignOutHomePageController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('signOutHomePage');
                    return $translate.refresh();
                }],
                entities: ['$stateParams', 'NasracWebContent', function($stateParams, NasracWebContent) {
                    return NasracWebContent.getPage({page : 'home'}).$promise;
                }],


            }
        });
    }
})();
